<div class="content" data-test-id="forgot-password-content">
  @if (requestSent) {
  <div data-test-id="forgot-password-email-sent-section">
    <p class="messageTitle" data-test-id="forgot-password-email-sent-title">
      Check your email!
    </p>
    <p class="messageText" data-test-id="forgot-password-email-sent-message">
      If an account with {{ email() }} exists, an email has been sent with
      instructions to reset your password.
    </p>
  </div>
  } @else {
  <form
    *ngIf="!requestSent"
    class="form"
    data-test-id="forgot-password-form"
    (submit)="submit($event)"
  >
    <app-view
      [direction]="ViewDirection.COLUMN"
      [gap]="Spacing.SMALL"
      [align]="ViewAlign.CENTER"
      [spacingBottom]="Spacing.LARGE"
    >
      <app-text
        [type]="TextType.TITLE"
        [size]="TextSize.TITLE_3"
        [height]="TextHeight.TITLE_4"
        [weight]="TextWeight.BOLD"
        [color]="TextColor.NEUTRAL_8"
        >Forgot Password?</app-text
      >
      <app-text
        [size]="TextSize.BODY_2"
        [height]="TextHeight.MEDIUM"
        [color]="TextColor.NEUTRAL_6"
        [weight]="TextWeight.REGULAR"
        >Enter your email, and we’ll send a reset link.</app-text
      >
    </app-view>
    <app-text-input
      class="field"
      [(value)]="email"
      [type]="InputType.EMAIL"
      placeholder="Email"
      [error]="emailError"
      errorMessage="{{ emailErrorMessage }}"
      [size]="InputSize.LARGE"
      [width]="InputWidth.FULL"
      [direction]="InputDirection.VERTICAL"
      [spacingBottom]="Spacing.LARGE"
      data-test-id="forgot-password-email-input"
    ></app-text-input>
    <p
      *ngIf="invalidFormatting"
      class="invalidFormatting"
      data-test-id="forgot-password-invalid-formatting-message"
    >
      {{ invalidFormattingMessage }}
    </p>
    <app-view
      [direction]="ViewDirection.COLUMN"
      [gap]="Spacing.LARGE"
      [align]="ViewAlign.CENTER"
    >
      <app-button
        [type]="ButtonType.PRIMARY"
        [nativeType]="NativeButtonType.SUBMIT"
        [size]="ButtonSize.LARGE"
        [spacingBottom]="Spacing.NONE"
        data-test-id="forgot-password-submit-button"
      >
        Submit
      </app-button>
      <a
        class="form-link"
        routerLink="/login"
        data-test-id="forgot-password-back-to-login-link"
      >
        Back to login
      </a>
    </app-view>
  </form>
  }
  <app-toast [position]="ToastPosition.FORM"></app-toast>
</div>
